module.exports = __webpack_public_path__ + "static/img/h5Gif.feb1e91.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5Gif.gif
// module id = 1Jeh
// module chunks = 2